import { render, staticRenderFns } from "./FirmsEmployee.vue?vue&type=template&id=1671d7b2&scoped=true"
import script from "./FirmsEmployee.vue?vue&type=script&lang=ts"
export * from "./FirmsEmployee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671d7b2",
  null
  
)

export default component.exports